/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S6_Label_AddressInputs */

const tr_iletisim_s6_label_address = /** @type {(inputs: Iletisim_S6_Label_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres`)
};

const en_iletisim_s6_label_address = /** @type {(inputs: Iletisim_S6_Label_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const de_iletisim_s6_label_address = /** @type {(inputs: Iletisim_S6_Label_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse`)
};

const ru_iletisim_s6_label_address = /** @type {(inputs: Iletisim_S6_Label_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Iletisim_S6_Label_AddressInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s6_label_address = /** @type {((inputs?: Iletisim_S6_Label_AddressInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S6_Label_AddressInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s6_label_address(inputs)
	if (locale === "de") return de_iletisim_s6_label_address(inputs)
	if (locale === "ru") return ru_iletisim_s6_label_address(inputs)
	return tr_iletisim_s6_label_address(inputs)
});